import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-shell',
  template: `
    <app-plain-shell [customerSpaceId]="customerSpaceId">
      <router-outlet />
    </app-plain-shell>
  `,
})
export class ShellComponent {
  @Input() customerSpaceId: string;
}
